<nz-form-item>
    <nz-form-label *ngIf="showLabel" [nzFlex]="labelWidth" [nzRequired]="nzRequired">
        {{label$ | async}}
    </nz-form-label>
    <nz-form-control [nzFlex]="'auto'" #control [nzValidateStatus]="validateControl">
        <ng-content>
        </ng-content>
        <mm-form-error [labelName]="label"></mm-form-error>
    </nz-form-control>
</nz-form-item>